module.exports = __webpack_public_path__ + "media/41.db9013f9.wav";